import React, { useState, useEffect } from 'react';
import format from 'string-format';
import _path from 'ramda/src/path';
import _clone from 'ramda/src/clone';
import PropTypes from 'prop-types';
import SearchReblast from '../../../API/SearchReblast';
import Matangazo from '../../../API/Matangazo';
import UserActivity from '../../../API/UserActivity';
import resx from '../../../utilities/resx';
import { RESX_GLOBAL, RESX_LISTINGS, RESX_REBLASTS } from '../../../Constants';
import { withMessage } from '../Message';
import ReblastContainer from '../Reblast/ReblastContainer';
import UserActivityContainer from '../UserActivity/Container';
import InFeedAd from '../InFeedAd/InFeedAd';
import CreatePost from './CreatePost';
import EmptyFeed from './EmptyFeed';
import LoadingFeedPlaceholder from './LoadingFeedPlaceholder';
import FeedDataSource from './FeedDataSourceEnum';
import GeneralUtility from '../../../utilities/generalUtility';
import SearchFeed from './SearchFeed';
import JoinGroup from '../../Feed/JoinGroup';

const pendingRequests = [];

function FeedContainer(props) {
    const [feedJson, setFeedJson] = useState([]);
    const [reblasts, setReblasts] = useState([]);
    const [newPosts, setNewPosts] = useState(0);
    const [loading, setLoading] = useState(true);
    const [loadingActivity, setLoadingActivity] = useState(true);
    const [feedJsonMoreData, setFeedJsonMoreData] = useState([]);
    const [skipCount, setSkipCount] = useState(0);
    const [currentQuery, setCurrentQuery] = useState(null);
    const [count, setCount] = useState(0);
    const [ads, setAds] = useState(null);
    const [activityFeed, setActivityFeed] = useState(null);
    const [showPlaceholder, setShowPlaceholder] = useState(true);

    const groupsCanPinByCurrentUser = _path(['RESAAS', 'User2', 'GroupsCanPinByCurrentUser'], window);
    const groupsOwnedByCurrentUser = _path(['RESAAS', 'User2', 'GroupsOwnedByCurrentUser'], window);
    const isCommercialExperience = _path(['RESAAS', 'Environment', 'Experience'], window) === 'commercial';

    const firmID = _path(['firmorgroup', 'GroupId'], props);
    const groupUniqueName = _path(['firmorgroup', 'GroupUniqueName'], props);
    const canPinPost = firmID && groupsCanPinByCurrentUser ? groupsCanPinByCurrentUser.includes(firmID) : false;
    const isGroupAdmin = firmID && groupsOwnedByCurrentUser ? groupsOwnedByCurrentUser.includes(firmID) : false;
    const isProUser = _path(['RESAAS', 'User2', 'IsProfessional'], window);
    const isUltimateUser = _path(['RESAAS', 'User2', 'PremiumPlus'], window);
    const isAuthenticated = _path(['RESAAS', 'User2', 'UserId'], window);
    const loadMoreNumber = 20;
    const adSpacing = 10;
    const getActivity = isAuthenticated && (props.page === 'myprofile' || props.page === 'userprofile');
    const isUltimateOnlyGroup = _path(['firmorgroup', 'GroupSubtype'], props) === 4 && _path(['firmorgroup', 'ConfigurationFlags', 'UltimateOnly'], props);

    const logFeedError = (error, src) => {
        if (props.hashtag) {
            GeneralUtility.logWebRequestFailure(error, `fetch hashtag ${props.hashtag} from ${src}`);
            return;
        }
        GeneralUtility.logWebRequestFailure(error, `fetch feed from ${src}`);
    };

    const handleNewReblast = (e, data) => {
        if (data && (data.FeedId || data.FeedUniqueName)) {
            const isGlobalFeed =
                (!isCommercialExperience && props.globalFeed && data.FeedId === 'global') ||
                (isCommercialExperience && props.globalFeed && data.FeedUniqueName === 'resaas-commercial');
            const myPostFeed = props.myPosts && data.FeedId === 'myposts';
            const isLocalFeed = props.localFeed && data.FeedId === 'fdfe55f9-a325-479a-b1e2-92c4776c1f40';
            const isCurrentFirmOrGroup = props.firmorgroup && data.FeedId === props.firmorgroup.GroupId;
            const isConnections = props.connections && data.FeedId === 'connections';
            if (isGlobalFeed || isLocalFeed || isCurrentFirmOrGroup || myPostFeed || isConnections) {
                setNewPosts(prev => prev + 1);
            }
        }
    };

    const handleNewReblastSessionStorage = (reblasts, newReblastsInSessionStorage) => {
        const reblastsData = _clone(reblasts);
        newReblastsInSessionStorage.forEach(newReblastInSessionStorage => {
            if (newReblastInSessionStorage.FeedPage === window.location.pathname) {
                const matchingIdentifier = reblasts.filter(
                    reblast => reblast.Identifier === newReblastInSessionStorage.Identifier
                );
                if (matchingIdentifier.length > 0) {
                    //remove reblast from session storage
                    newReblastsInSessionStorage = newReblastsInSessionStorage.filter(
                        newReblastInSessionStorage =>
                            newReblastInSessionStorage.Identifier !== matchingIdentifier[0].Identifier
                    );
                    sessionStorage.setItem('newReblast', JSON.stringify(newReblastsInSessionStorage));
                } else {
                    reblastsData.unshift(newReblastInSessionStorage);
                }
            }
        });

        return reblastsData;
    };

    const FetchReblasts = searchParams => {
        let query = {};
        setLoading(true);

        if (props.requestQuery) {
            query = props.requestQuery;
        }
        if (props.hashtag) {
            query.Keywords = props.hashtag;
        }

        let src = props.datasrc;
        if (searchParams) {
            src = FeedDataSource.azure;
            query = searchParams;
        }

        setNewPosts(0);
        switch (src) {
            case FeedDataSource.db:
                SearchReblast.browseDb(query)
                    .request.then(response => {
                        if (!_path(['data', 'SearchReblastResult', 'Success'], response)) {
                            throw _path(['data', 'SearchReblastResult', 'Message'], response);
                        }

                        const newReblastsInSessionStorage = sessionStorage.getItem('newReblast');
                        const data = newReblastsInSessionStorage
                            ? handleNewReblastSessionStorage(
                                  response.data.SearchReblastResult.Data,
                                  JSON.parse(newReblastsInSessionStorage)
                              )
                            : response.data.SearchReblastResult.Data;
                        setReblasts(data);
                        setLoading(false);
                    })
                    .catch(error => {
                        setLoading(false);

                        if (isUltimateOnlyGroup && firmorgroup.GroupUserType === null) {
                            return false;
                        }

                        props.message.addMessage({
                            message: resx(RESX_GLOBAL, 'GENERIC_WEBSERVICE_ERROR_MESSAGE'),
                            type: 'error',
                            autoDelete: false
                        });
                        logFeedError(error, 'db');
                    });
                break;
            case FeedDataSource.azure:
                SearchReblast.browseAzure(query)
                    .then(response => {
                        setLoading(false);
                        setCount(response.data.Count);
                        const newReblastsInSessionStorage = sessionStorage.getItem('newReblast');
                        const data = newReblastsInSessionStorage
                            ? handleNewReblastSessionStorage(
                                  response.data.Data,
                                  JSON.parse(newReblastsInSessionStorage)
                              )
                            : response.data.Data;
                        if (query.SkipCount) {
                            setFeedJsonMoreData(data);
                        } else {
                            setReblasts(data);
                        }
                    })
                    .catch(error => {
                        setLoading(false);

                        if (isUltimateOnlyGroup && firmorgroup.GroupUserType === null) {
                            return false;
                        }

                        props.message.addMessage({
                            message: resx(RESX_GLOBAL, 'GENERIC_WEBSERVICE_ERROR_MESSAGE'),
                            type: 'error',
                            autoDelete: false
                        });
                        logFeedError(error, 'azure');
                    });
                break;
            case FeedDataSource.onPage:
                setReblasts(_path(['gFeedJson'], window));
                setLoading(false);
                break;
            default:
        }
    };

    useEffect(() => {
        let mergedArray;

        if (activityFeed) {
            mergedArray = mergeAndSort(activityFeed.UserLikes, activityFeed.UserComments, reblasts);
        } else {
            mergedArray = reblasts;
        }

        setFeedJson(mergedArray);
    }, [activityFeed, reblasts]);

    useEffect(() => {
        if (getActivity) {
            // if we are getting activity we want loading to be false if
            // a) both are finished
            // b) one is finished and there is content

            if ((!loading && !loadingActivity) || (feedJson.length && (!loading || !loadingActivity))) {
                setShowPlaceholder(false);
            }
        } else {
            setShowPlaceholder(loading);
        }
    }, [loading, loadingActivity, feedJson]);

    const mergeAndSort = (userLikes, userComments, reblasts) => {
        const mergedArray = [...userLikes, ...userComments, ...reblasts];
        // Sort feeds based on CreatedOnFormatted property
        if (mergedArray.length) {
            mergedArray.sort((a, b) => {
                const dateA = a.CreatedOnFormatted;
                const dateB = b.CreatedOnFormatted;
                return dateB.localeCompare(dateA);
            });
        }

        return mergedArray;
    };

    // UserActivity Feed
    useEffect(() => {
        if (getActivity) {
            const userActivity = UserActivity.read({ userId: window.uID, take: 30 });

            GeneralUtility.appendPendingRequest(pendingRequests, userActivity);
            userActivity.request
                .then(response => {
                    setLoadingActivity(false);
                    setActivityFeed(_path(['data'], response));
                })
                .catch(error => {
                    setLoadingActivity(false);
                    GeneralUtility.logWebRequestFailure(
                        error,
                        `retrieve userActivity feed error from user profile page`
                    );
                });

            return () => {
                GeneralUtility.cleanupRequests(pendingRequests);
            };
        } else {
            setLoadingActivity(false);
        }
    }, []);

    //call the ads in - for search feed API we need to update the logic if want to show ads with new search
    useEffect(() => {
        if (!isCommercialExperience && props.showads && feedJson.length > 9 && !ads) {
            const adsNeeded = Math.ceil(feedJson.length / adSpacing);
            Matangazo.browse({ Count: adsNeeded, Keyword: 2 })
                .then(response => {
                    if (!_path(['data', 'Success'], response)) {
                        throw new Error(_path(['data', 'Message'], response));
                    }
                    const adsData = _path(['data', 'Data'], response);
                    if (adsData.length) {
                        setAds(adsData);
                    }
                })
                .catch(error => {
                    GeneralUtility.logWebRequestFailure(error, `fetch infeed ads from FeedContainer.js`);
                });
        }
    }, [feedJson]);

    //update the feed with ads in
    useEffect(() => {
        if (ads && ads.length) {
            const newFeedJson = _clone(feedJson);
            for (let it = 0; it < ads.length; ++it) {
                newFeedJson.splice(1 + it * adSpacing, 0, ads[it]);
            }
            setFeedJson(newFeedJson);
        }
    }, [ads]);

    //start fresh when the base query is changed.(not counting the skipCount)
    useEffect(() => {
        //empty everything
        setCount(0);
        setSkipCount(0);
        setFeedJsonMoreData([]);
        if (currentQuery) {
            FetchReblasts(currentQuery);
        } else {
            FetchReblasts();
        }
    }, [currentQuery]);

    // hanlde the initial cache request
    useEffect(() => {
        if (count > loadMoreNumber && !skipCount) {
            const newQuery = _clone(currentQuery);
            newQuery.SkipCount = skipCount + loadMoreNumber;
            FetchReblasts(newQuery);
        }
    }, [feedJson]);

    // handle the subsequent cache request
    useEffect(() => {
        if (skipCount > 0 && skipCount + loadMoreNumber < count) {
            const newQuery = _clone(currentQuery);
            newQuery.SkipCount = skipCount + loadMoreNumber;
            FetchReblasts(newQuery);
        }
    }, [skipCount]);

    const handleLoadMoreBtn = () => {
        const feedJsonClone = _clone(feedJson);
        const newFeedJsonData = [...feedJsonClone, ...feedJsonMoreData];
        setFeedJson(newFeedJsonData);
        setFeedJsonMoreData([]);
        setSkipCount(skipCount + loadMoreNumber);
    };

    // get all deleted reblasts from sessionStorage
    const deletedPostsFromSessionStorage = new Set([]);
    let idx = 1;
    if (window.Modernizr && window.Modernizr.sessionstorage) {
        while (true) {
            const sessionItem = sessionStorage.getItem(`reblast#${idx}`);
            if (!sessionItem) {
                break;
            } else {
                deletedPostsFromSessionStorage.add(sessionItem);
            }
            ++idx;
        }
    }

    // runs once similar to componentDidMount
    useEffect(() => {
        $('body').on('NewReblast', handleNewReblast);

        // cleanup
        return function cleanup() {
            $('body').off('NewReblast', handleNewReblast);
        };
    }, []);

    function deleteReblastFromState(reblastId) {
        const feedWithReblastRemoved = feedJson.filter(
            reblast => (reblast.ReblastId || reblast.Identifier) !== reblastId
        );
        setFeedJson(feedWithReblastRemoved);
    }

    function contentTypeIntToString(intContentType) {
        switch (intContentType) {
            case 1:
                return 'Listing';
            case 2:
                return 'Answer';
            case 3:
                return 'Reblast';
            case 4:
                return 'Image';
            case 5:
                return 'Pdf';
            case 6:
                return 'Referral';
            case 7:
                return 'PreMarketListing';
            case 101:
                return 'Document';
            case 0:
            default:
                return 'Unknown';
        }
    }

    function reblastPropsAdapter(reblast) {
        let ret = null;
        if (reblast.AdId && reblast.AdId !== '00000000-0000-0000-0000-000000000000') {
            return reblast;
        }
        const isReblastOwner = _path(['User2', 'UserId'], RESAAS) === reblast.UserId;

        switch (props.datasrc) {
            case FeedDataSource.db:
            case FeedDataSource.azure:
                let listingGoogleMapImage;
                if (_path(['Listing'], reblast) && _path(['Listing', 'Images'], reblast) === null) {
                    const rs = GeneralUtility.getGoogleStaticMap(_path(['Listing'], reblast));
                    if (rs) {
                        listingGoogleMapImage = rs;
                    } else {
                        listingGoogleMapImage = null;
                    }
                }
                ret = {
                    CanPostComments: window.RESAAS.User2.UserId !== undefined,
                    CanReadComments: window.RESAAS.User2.UserId !== undefined,
                    ContentTrackingUrl: reblast.ContentTrackingUrl,
                    ContentType: contentTypeIntToString(reblast.ContentType),
                    FileAttachmentUrl: _path(['Attachment', 'AttachmentDocument', 'Url'], reblast) || '',
                    FirmID: firmID,
                    GroupLinkPublicPage: reblast.FirmGroupUniqueName ? `/feed/group/${reblast.FirmGroupUniqueName}` : '',
                    GroupName: reblast.FirmGroupName,
                    HasCommented: false,
                    HasImageInAttachment:
                        _path(['Attachment', 'AttachmentImage'], reblast) !== null &&
                        _path(['Attachment', 'AttachmentImage'], reblast) !== undefined,
                    HasFileInAttachment:
                        _path(['Attachment', 'AttachmentDocument'], reblast) !== null &&
                        _path(['Attachment', 'AttachmentDocument'], reblast) !== undefined,
                    HasListing: _path(['Listing'], reblast) !== null,
                    HideFirmFeed: false,
                    ImageLargeAttachmentUrl: _path(['Attachment', 'AttachmentImage', '1', 'Url'], reblast) || '',
                    InteriorSize: _path(['Listing', 'InteriorSize'], reblast) !== null,
                    InteriorSizeUnit: _path(['Listing', 'InteriorSizeUnit'], reblast) !== null,
                    IsFeatured: reblast.IsFeatured && reblast.FirmGroupUniqueName === groupUniqueName,
                    IsReblastOwner: isReblastOwner,
                    IsScrubbed: reblast.IsScrubbed,
                    ListingAddress: _path(['Listing', 'Address'], reblast) || '',
                    ListingCity: _path(['Listing', 'City'], reblast) || '',
                    ListingCoopFeeAmount: _path(['Listing', 'CoopFeeAmount'], reblast) || '',
                    ListingCountry: _path(['Listing', 'Country'], reblast) || '',
                    ListingCurrencyCode: _path(['Listing', 'CurrencyCode'], reblast) || '',
                    ListingFormattedPrice: _path(['Listing', 'FormattedPrice'], reblast) || '',
                    ListingFormattedPricePerAmount: _path(['Listing', 'FormattedPricePerAmount'], reblast) || '',
                    ListingHasImage: _path(['Listing', 'Images'], reblast) !== null || listingGoogleMapImage !== null,
                    ListingImageUrl: _path(['Listing', 'Images', '0', 'Url'], reblast)
                        ? _path(['Listing', 'Images', '0', 'Url'], reblast)
                        : listingGoogleMapImage,
                    ListingIsSold: _path(['Listing', 'IsSold'], reblast) || '',
                    ListingIsLease: _path(['Listing', 'ListingTransactionType'], reblast) === 1,
                    ListingLargeImageUrl: _path(['Listing', 'Images', '1', 'Url'], reblast)
                        ? _path(['Listing', 'Images', '1', 'Url'], reblast)
                        : listingGoogleMapImage,
                    ListingNumberBathrooms: _path(['Listing', 'Bathrooms'], reblast) || '',
                    ListingNumberBedrooms: _path(['Listing', 'Bedrooms'], reblast) || '',
                    ListingPrice: _path(['Listing', 'Price'], reblast) || '',
                    ListingPricePerAmount: _path(['Listing', 'PricePerAmount'], reblast) || '',
                    ListingPriceSuffix: _path(['Listing', 'PriceSuffix'], reblast) || '',
                    ListingPropertySize: _path(['Listing', 'PropertySize'], reblast) || '',
                    ListingInteriorSize: _path(['Listing', 'InteriorSize'], reblast),
                    ListingInteriorSizeUnit: _path(['Listing', 'InteriorSizeUnit'], reblast),
                    ListingSeoUrl: _path(['Listing', 'SeoUrl'], reblast) || '',
                    ListingSoldLabel:
                        _path(['Listing', 'ListingTransactionType'], reblast) === 0
                            ? resx(RESX_LISTINGS, 'SOLD_STATUS_TEXT')
                            : resx(RESX_LISTINGS, 'LEASED_STATUS_TEXT'),
                    ListingState: _path(['Listing', 'State'], reblast) || '',
                    ListingSuiteNumber2: _path(['Listing', 'SuiteNumber2'], reblast) || '',
                    ListingVirtualTourAddress: _path(['Listing', 'VirtualTourAddress'], reblast) || '',
                    ListingMarketStatus: _path(['Listing', 'MarketStatus'], reblast),
                    ReblastCreatedOn: reblast.CreatedOnFormatted,
                    ReblastDescription: reblast.Message,
                    ReblastId: reblast.Identifier,
                    ReblastLikeCounter: reblast.LikedCount,
                    ReblastType: reblast.ReblastType,
                    TotalViewCount: reblast.TotalViewCount,
                    UniqueViewCount: reblast.UniqueViewCount,
                    User: {
                        City: reblast.City,
                        Country: reblast.Country,
                        CountryId: reblast.CountryId,
                        FirmName: reblast.FirmName,
                        FirmUniqueName: reblast.FirmUniqueName,
                        FirstName: reblast.FirstName,
                        LastName: reblast.LastName,
                        Latitude: reblast.UserLatitude,
                        Longitude: reblast.UserLongitude,
                        State: reblast.Province,
                        UserDomain: reblast.DomainUrl,
                        UserProfilePictureUrl: null,
                        WebsiteId: reblast.WebsiteId,
                        HasProfileBadge: reblast.HasProfileBadge,
                        HasPremiumPlusBadge: reblast.HasPremiumPlusBadge
                    },
                    UserLikedReblast: _path(['Like', 'IsLikedByUser'], reblast),
                    Comments: reblast.Comments,
                    TotalCommentCount: reblast.TotalCommentCount
                };
                break;
            case FeedDataSource.onPage:
                ret = {
                    CanPostComments: reblast.CanPostComments,
                    CanReadComments: reblast.CanReadComments,
                    ContentTrackingUrl: reblast.ContentTrackingUrl,
                    ContentType: contentTypeIntToString(reblast.ContentType),
                    FileAttachmentUrl: reblast.FileAttachmentUrl,
                    FirmID: firmID,
                    GroupLinkPublicPage: reblast.GroupLinkPublicPage,
                    GroupName: reblast.GroupName,
                    HasCommented: reblast.HasCommented,
                    HasImageInAttachment: reblast.HasImageInAttachment,
                    HasFileInAttachment: reblast.HasFileInAttachment,
                    HasListing: reblast.HasListing,
                    HideFirmFeed: reblast.HideFirmFeed,
                    ImageLargeAttachmentUrl: reblast.ImageLargeAttachmentUrl,
                    IsFeatured: reblast.IsFeatured && reblast.FirmGroupUniqueName === groupUniqueName,
                    IsScrubbed: reblast.IsScrubbed,
                    IsReblastOwner: _path(['User2', 'WebsiteId'], RESAAS) === reblast.UserWebsiteId,
                    ListingAddress: reblast.ListingAddress,
                    ListingCity: reblast.ListingCity,
                    ListingCoopFeeAmount: reblast.ListingCoopFeeAmount,
                    ListingCountry: reblast.ListingCountry,
                    ListingCurrencyCode: reblast.ListingCurrencyCode,
                    ListingFormattedPrice: reblast.ListingFormattedPrice,
                    ListingFormattedPricePerAmount: reblast.ListingFormattedPricePerAmount,
                    ListingHasImage: reblast.ListingHasImage,
                    ListingImageUrl: reblast.ListingImageUrl,
                    ListingInteriorSize: reblast.ListingInteriorSize,
                    ListingInteriorSizeUnit: reblast.ListingInteriorSizeUnit,
                    ListingIsLease: reblast.ListingTransactionType === 1,
                    ListingIsSold: reblast.ListingIsSold,
                    ListingLargeImageUrl: reblast.ListingLargeImageUrl,
                    ListingNumberBathrooms: reblast.ListingNumberBathrooms,
                    ListingNumberBedrooms: reblast.ListingNumberBedrooms,
                    ListingPrice: reblast.ListingPrice,
                    ListingPricePerAmount: reblast.ListingPricePerAmount,
                    ListingPriceSuffix: reblast.ListingPriceSuffix,
                    ListingPropertySize: reblast.ListingPropertySize,
                    ListingSeoUrl: reblast.ListingSeoUrl,
                    ListingSoldLabel: reblast.ListingSoldLabel,
                    ListingState: reblast.ListingState,
                    ListingSuiteNumber2: reblast.ListingSuiteNumber2,
                    ListingVirtualTourAddress: reblast.ListingVirtualTourAddress,
                    ListingMarketStatus: reblast.ListingMarketStatus,
                    ReblastCreatedOn: reblast.ReblastCreatedOn,
                    ReblastDescription: reblast.ReblastDescription,
                    ReblastId: reblast.ReblastId,
                    ReblastLikeCounter: reblast.ReblastLikeCounter,
                    ReblastType: reblast.ReblastType,
                    TotalViewCount: reblast.TotalViewCount,
                    UniqueViewCount: reblast.UniqueViewCount,
                    User: {
                        City: reblast.City,
                        FirmName: reblast.FirmName,
                        FirmUniqueName: reblast.FirmUniqueName,
                        FirstName: reblast.UserFirstname,
                        LastName: reblast.UserLastname,
                        Latitude: reblast.UserLatitude,
                        Longitude: reblast.UserLongitude,
                        State: reblast.Province,
                        UserDomain: reblast.UserDomain,
                        UserProfilePictureUrl: reblast.UserProfilePictureUrl,
                        WebsiteId: reblast.WebsiteId,
                        HasProfileBadge: reblast.HasProfileBadge,
                        HasPremiumPlusBadge: reblast.HasPremiumPlusBadge
                    },
                    UserLikedReblast: reblast.UserLikedReblast,
                    Comments: reblast.ReblastComments.Comments,
                    TotalCommentCount: reblast.TotalCommentCount
                };
                if (ret.Comments) {
                    for (let it = 0; it < ret.Comments.length; ++it) {
                        ret.Comments[it].CommentId = ret.Comments[it].Id;
                        ret.Comments[it].FirstName = ret.Comments[it].UserFirstname;
                        ret.Comments[it].LastName = ret.Comments[it].UserLastname;
                        ret.Comments[it].DateCreatedFormatted = ret.Comments[it].CreatedOn;
                        ret.Comments[it].DomainUrl = ret.Comments[it].UserDomain;
                        ret.Comments[it].Attachment = {
                            AttachmentDocument: null,
                            AttachmentImage: null
                        };
                        if (ret.Comments[it].HasImageInAttachment) {
                            ret.Comments[it].Attachment.AttachmentImage = [
                                { Url: ret.Comments[it].ImageAttachmentUrl },
                                { Url: ret.Comments[it].ImageLargeAttachmentUrl }
                            ];
                        }
                        if (ret.Comments[it].HasFileInAttachment) {
                            ret.Comments[it].Attachment.AttachmentDocument = {
                                Url: ret.Comments[it].FileAttachmentUrl
                            };
                        }
                    }
                }
                break;
            default:
                return null;
        }
        ret.commentsFetch = false;
        ret.commentsDisplayCount = 2;
        return ret;
    }

    // eslint-disable-next-line no-bitwise
    const canViewSearchFeed =
        isProUser && props.firmorgroup && _path(['firmorgroup', 'ConfigurationFlags', 'SearchFeed'], props);

    return (
        <React.Fragment>
            {props.hashtag && (
                <div className="hashtag-header layout-header re-container-outer">
                    <h2>{format(resx(RESX_REBLASTS, 'JOIN_HASH_CONVERSATION'), props.hashtag)}</h2>
                </div>
            )}

            {isProUser && !props.hideCreatePost && (
                <CreatePost
                    hashtag={props.hashtag}
                    firmorgroup={props.firmorgroup}
                    isGroupMember={props.isGroupMember}
                />
            )}

            {canViewSearchFeed ? (
                <SearchFeed
                    firmorgroup={props.firmorgroup}
                    doSearchFeed={params => {
                        setCurrentQuery(params);
                    }}
                    doClearSearch={() => {
                        setCurrentQuery(null);
                    }}
                />
            ) : null}

            <LoadingFeedPlaceholder loading={showPlaceholder} />

            {!loading && newPosts >= 1 ? (
                <div className="reblasts-stream re-reblasts-stream-visible" data-testid="stream-count">
                    <a
                        href="#"
                        className="reblasts-stream-count"
                        onClick={() => {
                            FetchReblasts();
                        }}
                    >
                        <span className="stream-text text-bold">
                            {newPosts > 1
                                ? format(resx(RESX_REBLASTS, 'NEW_POSTS'), newPosts)
                                : resx(RESX_REBLASTS, 'NEW_POST')}
                        </span>
                    </a>
                </div>
            ) : null}

            {isUltimateOnlyGroup && !isUltimateUser && !loading && !loadingActivity && !feedJson.length ? (
                // ultimate only group user is not ultimate
                <article className="re-container re-container-outer re-ultimateOnlyGroup-feedCTA" data-testid="ultimate-only-upgrade">
                    <h2 className="re-text-lg re-text-semibold">Oh No! You don’t have access to this group.</h2>

                    <p>
                        The <strong>Performance Masterclass</strong> group content is an absolute game-changer. You’re
                        currently missing out on all the incredible learning tracks, accountability coaching, and
                        regular sessions with industry leaders.
                    </p>

                    <p>To gain access upgrade to RESAAS Ultimate.</p>

                    <div className="re-ultimateOnlyGroup-feedCTA-buttonWrapper">
                        <a href="/pricing" className="re-btn re-btn-large">
                            Upgrade
                        </a>
                    </div>
                    <a href="https://get.resaas.com/resaas-performance-master-class/" target="_blank">
                        Find out more about the Performance Masterclass
                    </a>
                </article>
            ) : null}

            {isUltimateOnlyGroup &&
            isUltimateUser &&
            !props.isGroupMember &&
            !loading &&
            !loadingActivity &&
            !feedJson.length ? (
                // ultimate only group user is ultimate
                <article className="re-container re-container-outer re-ultimateOnlyGroup-feedCTA" data-testid="ultimate-only-join">
                    <h2 className="re-text-lg re-text-semibold">Oh No! You don’t have access to this group - but you could.</h2>
                    <p>
                        The <strong>Performance Masterclass</strong> group content is an absolute game-changer and
                        available with your current subscription, join the group now.
                    </p>

                    <div className="re-ultimateOnlyGroup-feedCTA-buttonWrapper">
                        <JoinGroup buttonFullWidth={ false } />
                    </div>
                    <a href="https://get.resaas.com/resaas-performance-master-class/" target="_blank">
                        Find out more about the Performance Masterclass
                    </a>
                </article>
            ) : null}

            {(!isUltimateOnlyGroup || (isUltimateOnlyGroup && isUltimateUser && props.isGroupMember)) &&
            !loading &&
            !loadingActivity &&
            !feedJson.length ? (
                <div className="message no-content">
                    <EmptyFeed page={props.page} isGroupMember={props.isGroupMember} />
                </div>
            ) : null}

            {feedJson.map((reblast, index) => {
                if (reblast.UserActivityType) {
                    const userData = { ...activityFeed };
                    delete userData.UserLikes;
                    return (
                        <UserActivityContainer key={`${reblast.ContentId}-${index}`} data={reblast} user={userData} />
                    );
                }

                const initalState = reblastPropsAdapter(reblast);
                // skip rendering reblast if it was deleted
                if (deletedPostsFromSessionStorage.has(initalState.ReblastId)) {
                    return null;
                }

                if (initalState.AdId && initalState.AdId !== '00000000-0000-0000-0000-000000000000') {
                    return <InFeedAd key={`ad-${initalState.AdId}`} data={initalState} />;
                }

                return (
                    <ReblastContainer
                        canPinPost={canPinPost}
                        data={initalState}
                        deleteReblastFromState={deleteReblastFromState}
                        isFeed={true}
                        isGroupAdmin={isGroupAdmin}
                        key={initalState.ReblastId}
                        lazy={true}
                    />
                );
            })}

            {feedJsonMoreData.length ? (
                <button
                    className="re-btn re-btn-large re-btn-grey re-btn-full-width"
                    onClick={handleLoadMoreBtn}
                    data-testid="loadmore"
                >
                    {resx(RESX_GLOBAL, 'LOAD_MORE_BUTTON_TEXT')}
                </button>
            ) : null}
        </React.Fragment>
    );
}

FeedContainer.propTypes = {
    hideCreatePost: PropTypes.bool,
    requestQuery: PropTypes.object,
    message: PropTypes.object,
    hashtag: PropTypes.string,
    datasrc: PropTypes.number.isRequired,
    showads: PropTypes.bool,
    firmorgroup: PropTypes.object,
    globalFeed: PropTypes.bool,
    localFeed: PropTypes.bool
};

export default withMessage(FeedContainer);
